package ff.log

fun trace(log: Any?) {
    // todo check if logging enabled
    log?.also { console.log(it) }
}